<template>
  <div class="wrapper">
    <ul class="list">
      <li v-for="item in list" :key="item.id">
        <div class="content" @click="zhuantiao(item.url)">
          <span>
            <span>{{item.title}}</span>
            <span>{{item.digest}}</span>
          </span>
          <img :src="item.thumbUrl">
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getItmPage } from "@/request/api.js"
export default {
  data() {
    return {
      list: []
    };
  },
  async created() {
    this.getlist()
  },
  methods: {
    async getlist(){
      let map = {
        itmtype: 2, // 1 新闻动态, 2 健康宣教
        queryRequest: {
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortOrder: ""
        }
      }
      let res = await getItmPage(map);
      this.list = res.data.obj
    },
    zhuantiao(url){
      document.location = url
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #EDEDED;
  .list{
    display: flex;
    flex-flow: column nowrap;
    >li{
      background: #fff;
      margin: 10px 10px 0px;
      height: 120px;
      border-radius: 8px;
      .content{
        display: flex;
        flex-flow: row nowrap;
        padding: 30px 20px 20px;
        height: 100%;
        >span{
          flex: 1;
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
          >span:nth-child(1){
            font-size: 16px;
            font-weight: normal;
            letter-spacing: 1px;
            overflow: hidden;
            text-overflow: ellipsis;  /* 超出部分省略号 */
            word-break: break-all;  /* break-all(允许在单词内换行。) */  
            display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
            -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2; /* 显示的行数 */
          }
          >span:nth-child(2){
            margin-top: 3px;
            font-size: 12px;
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        >img{
          width: 70px;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/HospitalInformation/HealthEducation.vue